import { render, staticRenderFns } from "./CashRegisters.vue?vue&type=template&id=f66fc8c2&scoped=true"
import script from "./CashRegisters.vue?vue&type=script&lang=js"
export * from "./CashRegisters.vue?vue&type=script&lang=js"
import style0 from "./CashRegisters.vue?vue&type=style&index=0&id=f66fc8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66fc8c2",
  null
  
)

export default component.exports